import React from 'react';
import dollars from '../../dollar-format';
import {dateISOtoUS} from '../../date-converter';
import imgSrc from 'arcdynamic-resize';
import {athcapBlueLogo, athcapLogo,striveWhiteLogo} from "../../consts/consts";

const noPropertiesPerPage = 9;
const minNoPropertiesPerPage = 3;

function integer(value) {
    if (value === undefined || value === null || value === '') return '';
    return Math.round(Number(value)).toLocaleString();
}


function percent(value, withDecimals = true) {
    if (value === undefined || value === null || value === '') return '';
    if (withDecimals)
        return Number(value).toFixed(2) + '%';
    return parseInt(value) + '%';
}
function capitalizeFirstLetter(str){
    return str && str[0].toUpperCase() + str && str.slice(1);
}

const Print = (props) => {
    const {listings} = props;

    if (!listings) return null;
    const selectedComps = props.comps;
    const query = props.location.query;
    const isHscAgent = props.isHscAgent;
    const isHSC = query.SOURCE === 'HSC';
    const isClosed = query.CLOSE_OF_ESCROW_MIN || query.CLOSE_OF_ESCROW_MAX || query.STATUS === 'Closed' || query.HSC_STATUS === 'Closed';
    const isSTNL = query.TYPE === 'STNL';
    let columns = [];
function safeFilePath(f) {
  try {
    return decodeURIComponent(f); // test decode to trigger early
  } catch (e) {
    console.warn("Malformed URI component in file:", f);
    return f.replace(/%/g, ''); // or any fallback logic
  }
}
    if(selectedComps === 'lease'){
        columns.push(
            {
                name: 'Category',
                render: (el) => el.category,
                average: false,
            },
            {
                name: 'Type',
                render: (el) => el.type,
                average: false,
            },
            {
            name: "Photo",
            render: (el) => {

              if (el.website_photo_1) {
                const file = (el.website_photo_1 || "").trim();
                let src = "";

                if (file.startsWith("http")) {
                  // Already a full URL → use directly
                  src = file;
                } else {
                  // Relative path → build with arc.path.media
                  src = imgSrc(arc.path.media + safeFilePath(file), 100, 50);
                }

                return (
                  <img
                    src={src}
                    alt=""
                    style={{
                      display: "block",
                      width: "100px",
                      height: "50px",
                      objectFit: "cover", // keeps ratio, crops overflow
                      borderRadius: "4px", // optional, makes thumbnails cleaner
                    }}
                  />
                );
              }

              return null;
            },
            average: false,
          },
            {
                name: 'Name',
                render: (el) => el.name,
                average: false,
            },
            {
                name: 'Address',
                render: (el) => el.address,
                average: false,
            },
            {
                name: 'City',
                render: (el) => el.city,
                average: false,
            },
            {
                name: 'State',
                render: (el) => el.state,
                average: false,
            },
            {
                name: 'SQFT',
                render: (el) => integer(el.sqft),
                average: () => {
                    const list = listings.filter(x => x.sqft).map(x => parseFloat(x.sqft));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return integer(sum / list.length);
                    } else {
                        return null;
                    }
                },
            },
            {
                name: 'Rent/SQFT',
                render: (el) => dollars(el.rent_per_sqft, true),
                average: () => {
                    const list = listings.filter(x => x.rent_per_sqft).map(x => parseFloat(x.rent_per_sqft));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return dollars(sum / list.length);
                    } else {
                        return null;
                    }
                },
            },
            {
                name: <span>Year<br/>Built</span>,
                render: (el) => el.year_built,
                average: () => {
                    const list = listings.filter(x => x.year_built).map(x => parseFloat(x.year_built));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return Math.round(sum / list.length);
                    } else {
                        return null;
                    }
                },
            },
            {
                name: 'Occupancy',
                render: (el) => percent(el.vacancy, true),
                average: () => {
                    const list = listings.filter(x => x.vacancy).map(x => parseFloat(x.vacancy));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return percent(sum / list.length);
                    } else {
                        return null;
                    }
                },
            }
            
        );
    }
    if (isHSC) {
        columns.push({
            name: "Status",
            render: (el) => el.hsc_status,
            average: false,
        }, {
            name: 'Property',
            render: (el) => {
                return (
                    <div>
                        <div><strong>{el.name}</strong></div>
                        <div>{el.address}</div>
                        <div>{el.city}, {el.state} {el.zip}</div>
                    </div>
                )
            },
            average: false,
        }, {
            name: (
                <div>
                    <div>Price</div>
                    <div>Cap Rate</div>
                </div>
            ),
            render: (el) => {
                let price = el.hsc_price;
                let capRate = el.capitalization_rate;

                if (el.hsc_status && el.hsc_status.includes('Closed')) {
                    price = el.sold_price;
                    capRate = el.close_cap_rate;
                }

                return (
                    <div>
                        <div>{price == null || price === '' ? '-' : dollars(price)}</div>
                        <div>{capRate == null || capRate === '' ? '-' : percent(capRate)}</div>
                    </div>
                )
            },
            average: () => {
                const parts = [];
                let priceKey = '';
                let capRateKey = '';

                if (query.hsc_status && query.hsc_status.includes('Closed')) {
                    priceKey = 'SOLD_PRICE';
                    capRateKey = 'CLOSE_CAP_RATE';
                } else {
                    priceKey = 'HSC_PRICE';
                    capRateKey = 'CAPITALIZATION_RATE';
                }

                {
                    const list = listings.filter(x => x[priceKey]).map(x => parseFloat(x[priceKey]));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        parts.push(dollars(Math.round(sum / list.length)));
                    } else {
                        parts.push('-');
                    }
                }
                {
                    const list = listings.filter(x => x[capRateKey]).map(x => parseFloat(x[capRateKey]));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        parts.push(percent(sum / list.length));
                    } else {
                        parts.push('-');
                    }
                }
                return parts.map((x, i) => <div key={i}>{x}</div>);
            },
        }, {
            name: "Loan Amount",
            render: (el) => dollars(el.loan_amount),
            average: () => {
                const list = listings.filter(x => x.loan_amount).map(x => parseInt(x.loan_amount));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "LTV",
            render: (el) => percent(el.ltv, false),
            average: () => {
                const list = listings.filter(x => x.ltv).map(x => parseFloat(x.ltv));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Down Payment",
            render: (el) => dollars(el.down_payment),
            average: () => {
                const list = listings.filter(x => x.down_payment).map(x => parseInt(x.down_payment));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Rate",
            render: (el) => percent(el.interest_rate),
            average: () => {
                const list = listings.filter(x => x.interest_rate).map(x => parseFloat(x.interest_rate));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            }
        }, {
            name: "Amo",
            render: (el) => el.amortization,
            average: false,
        }, {
            name: "Term",
            render: (el) => el.term,
            average: false,
        }, {
            name: "Lender",
            render: (el) => el.lender_name,
            average: false,
        });
    } else if(selectedComps !== 'lease'){
        columns.push({
            name: 'Status',
            render: (el) => el.status,
            average: false,
        });

        if (isClosed) {
            columns.push({
                name: 'Close of Escrow',
                render: (el) => el.close_of_escrow ? dateISOtoUS(el.close_of_escrow) : '',
                average: false,
            });
        }

        columns.push(
            {
                name: 'Type',
                render: (el) => el.type,
                average: false,
            },
            {
            name: "Photo",
            render: (el) => {

              if (el.website_photo_1) {
                const file = (el.website_photo_1 || "").trim();
                let src = "";

                if (file.startsWith("http")) {
                  // Already full URL → use directly
                  src = file;
                } else {
                  // Internal relative path → go through imgSrc
                  src = imgSrc(arc.path.media + safeFilePath(file), 100, 50);
                }
                return (
                  <img
                    src={src}
                    alt="Property"
                    style={{
                      display: "block",
                      width: "100px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                );
              }

              return null;
            },
            average: false,
          },
            {
                name: 'Property',
                render: (el) => {
                    return (
                        <div>
                            <div><strong>{el.name}</strong></div>
                            <div>{el.address}</div>
                            <div>{el.city}, {el.state} {el.zip}</div>
                        </div>
                    )
                },
                average: false,
            },
            {
                name: (
                    <div>
                        <div>Price</div>
                        <div>Cap Rate</div>
                        <div>NOI</div>
                    </div>
                ),
                render: (el) => {
                    let price = '';
                    let capRate = '';
                    const noi = el.net_operating_income;
                    
                    if (el.status && el.status.includes('Closed')) {
                        price = el.sold_price;
                        capRate = el.close_cap_rate;
                    } else if (el.status && (el.status.includes('In Negotiation') || el.status.includes('Under Contract'))) {
                        price = el.negotiation_price;
                        capRate = el.negotiation_cap_rate;
                    } else {
                        price = el.list_price;
                        capRate = el.capitalization_rate;
                    }

                    return (
                        <div>
                            <div>{price == null || price === '' ? '-' : dollars(price)}</div>
                            <div>{capRate == null || capRate === '' ? '-' : percent(capRate)}</div>
                            <div>{noi == null || noi === '' ? '-' : dollars(noi)}</div>
                        </div>
                    )
                },
                average: () => {
                    const parts = [];
                    let priceKey = '';
                    let capRateKey = '';
                    let avgStatusList = [];
                    let avgCapRateList = [];

                    let statusArray;
                    if(query.STATUS) {                    
                    statusArray =   query.STATUS.split(',');
                    statusArray.forEach(status=>{
                        switch(status){
                            case "Active":
                                priceKey = 'LIST_PRICE';
                                capRateKey = 'CAPITALIZATION_RATE';
                                const activeList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const activeCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...activeList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...activeCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "Closed":
                                priceKey = 'SOLD_PRICE';
                                capRateKey = 'CLOSE_CAP_RATE';
                                const closedList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const closedCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...closedList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...closedCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "In Negotiation":
                                priceKey = 'NEGOTIATION_PRICE';
                                capRateKey = 'NEGOTIATION_CAP_RATE';
                                const inNagotiationList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const inNagotiationCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...inNagotiationList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...inNagotiationCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "Under Contract":
                                priceKey = 'NEGOTIATION_PRICE';
                                capRateKey = 'NEGOTIATION_CAP_RATE';
                                const underContractList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const underContractCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...underContractList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...underContractCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "Proposal":
                                priceKey = 'LIST_PRICE';
                                capRateKey = 'CAPITALIZATION_RATE';
                                const proposalList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const proposalCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...proposalList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...proposalCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "Removed":
                                priceKey = 'LIST_PRICE';
                                capRateKey = 'CAPITALIZATION_RATE';
                                const removedList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const removedCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...removedList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...removedCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "Property Info":
                                priceKey = 'LIST_PRICE';
                                capRateKey = 'CAPITALIZATION_RATE';
                                const propertyInfoList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const propertyInfoCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...propertyInfoList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...propertyInfoCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "Off Market Info":
                                priceKey = 'LIST_PRICE';
                                capRateKey = 'CAPITALIZATION_RATE';
                                const offMarketList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const offMarketCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...offMarketList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...offMarketCapRatelist.filter(value=>!isNaN(value)));
                                break;
                            case "Flagged":
                                priceKey = 'LIST_PRICE';
                                capRateKey = 'CAPITALIZATION_RATE';
                                const falggedList = listings.filter(x => x.status===status).map(x => parseFloat(x[priceKey]));
                                const flaggedCapRatelist = listings.filter(x => x.status===status).map(x => parseFloat(x[capRateKey]));
                                avgStatusList.push(...falggedList.filter(value=>!isNaN(value)));
                                avgCapRateList.push(...flaggedCapRatelist.filter(value=>!isNaN(value)));
                                break;
                        }

                    });
                }
                   /*  if (query.STATUS && query.STATUS.includes('Closed')) {
                        priceKey = 'SOLD_PRICE';
                        capRateKey = 'CLOSE_CAP_RATE';
                    } else if (query.STATUS && (query.STATUS.includes('In Negotiation') || query.STATUS.includes('Under Contract'))) {
                        priceKey = 'NEGOTIATION_PRICE';
                        capRateKey = 'NEGOTIATION_CAP_RATE';
                    } else {
                        priceKey = 'LIST_PRICE';
                        capRateKey = 'CAPITALIZATION_RATE';
                    } */

                    {
                        //const list = listings.filter(x => x[priceKey]).map(x => parseFloat(x[priceKey]));
                        if (avgStatusList.length) {
                            const sum = avgStatusList.reduce((a, b) => a + b);
                            parts.push(dollars(Math.round(sum / avgStatusList.length)));
                        } else {
                            parts.push('-');
                        }
                    }
                    {
                        //const list = listings.filter(x => x[capRateKey]).map(x => parseFloat(x[capRateKey]));
                        if (avgCapRateList.length) {
                            const sum = avgCapRateList.reduce((a, b) => a + b);
                            parts.push(percent(sum / avgCapRateList.length));
                        } else {
                            parts.push('-');
                        }
                    }
                    {
                        const list = listings.filter(x => x.net_operating_income).map(x => parseFloat(x.net_operating_income));
                        if (list.length) {
                            const sum = list.reduce((a, b) => a + b);
                            parts.push(dollars(Math.round(sum / list.length)));
                        } else {
                            parts.push('-');
                        }
                    }
                    return parts.map((x, i) => <div key={i}>{x}</div>);
                },
            },
        );

        columns.push({
            name: 'SQFT',
            render: (el) => integer(el.sqft),
            average: () => {
                const list = listings.filter(x => x.sqft).map(x => parseFloat(x.sqft));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return integer(sum / list.length);
                } else {
                    return null;
                }
            },
        }, {
            name: 'Rent/SQFT',
            render: (el) => dollars(el.rent_per_sqft, true),
            average: () => {
                const list = listings.filter(x => x.rent_per_sqft).map(x => parseFloat(x.rent_per_sqft));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return dollars(sum / list.length);
                } else {
                    return null;
                }
            },
        });

        if (isClosed) {
            columns.push({
                name: 'Close PSF',
                render: (el) => dollars(el.close_price_per_sqft),
                average: () => {
                    const list = listings.filter(x => x.close_price_per_sqft).map(x => parseFloat(x.close_price_per_sqft));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return dollars(sum / list.length);
                    } else {
                        return null;
                    }
                },
            });
        } else {
            columns.push({
                name: 'PSF',
                render: (el) => dollars(el.price_per_sqft),
                average: () => {
                    const list = listings.filter(x => x.price_per_sqft).map(x => parseFloat(x.price_per_sqft));
                    if (list.length) {
                        const sum = list.reduce((a, b) => a + b);
                        return dollars(sum / list.length);
                    } else {
                        return null;
                    }
                },
            });
        }

        columns.push({
            name: <span>Year<br/>Built</span>,
            render: (el) => el.year_built,
            average: () => {
                const list = listings.filter(x => x.year_built).map(x => parseFloat(x.year_built));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return Math.round(sum / list.length);
                } else {
                    return null;
                }
            },
        }, {
            name: 'Occupancy',
            render: (el) => percent(el.vacancy, true),
            average: () => {
                const list = listings.filter(x => x.vacancy).map(x => parseFloat(x.vacancy));
                if (list.length) {
                    const sum = list.reduce((a, b) => a + b);
                    return percent(sum / list.length);
                } else {
                    return null;
                }
            },
        });
        if (isSTNL) {
        columns.push({            
                name: <span>Remaining<br/>Term</span>,
                render: (el) => {
                    if (el.lease_expiration_date && el.close_of_escrow) {
                        const leaseExpiration = new Date(el.lease_expiration_date);
                        const closeOfEscrow = new Date(el.close_of_escrow);
                        const diff = leaseExpiration - closeOfEscrow;
    
                        if (diff !== diff) {
                            // NaN
                            return '';
                        }
    
                        if (diff <= 0) {
                            return 'Expired';
                        }
    
                        return Math.round(diff / (1000 * 60 * 60 * 24 * 365) * 2) / 2;
                    }
    
                    return '';
                },
                average: true,
            });
         }        
    }

    function renderPage({data, isLastPage, pageNo, totalPages}) {
        return (
            <React.Fragment>
                <div className='Print_head'>
                    <div className={`Print_head_logo ${isHscAgent ? 'hsc-agent' : isHSC ? 'hsc' : ''}`}>
                        <img src={arc.path.media + (isHscAgent ? athcapBlueLogo : isHSC ? athcapLogo : striveWhiteLogo)} alt=''/>
                    </div>
                </div>
                <div className='Print_body'>
                    <table>
                        <thead>
                        <tr>
                            {
                                columns.map((col, i) => <th className={`${isHscAgent ? 'hsc-agent':''}`} key={i}>{col.name}</th>)
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            data.map(x => (
                                <tr key={x.arcimedes_row_id}>
                                    {
                                        columns.map((col, i) => <td key={i}>{col.render(x)}</td>)
                                    }
                                </tr>
                            ))
                        }
                        </tbody>
                        <tfoot style={{display: isLastPage ? '' : 'none'}}>
                        <tr>
                            {
                                (() => {
                                    let colspan = 0;

                                    columns.every(x => {
                                        if (x.average === false) {
                                            colspan++;
                                            return true;
                                        }
                                    });

                                    return [<td className={`${isHscAgent ? 'hsc-agent':''}`}  key='x' colSpan={colspan}>AVERAGE:</td>].concat(columns.slice(colspan).map((col, i) => (
                                        <td className={`${isHscAgent ? 'hsc-agent':''}`}  key={i}>{typeof col.average === 'function' ? col.average() : null}</td>
                                    )))
                                })()
                            }
                        </tr>
                        </tfoot>
                    </table>
                </div>
                <div className={`Print_footer ${isHscAgent ? 'hsc-agent':''}`}>
                    {
                        isHSC || isHscAgent ?
                            '469-844-8024 | 17742 Preston Rd Suite 100 Dallas, TX 75252 | www.athenacapitalre.com'
                            :
                            '(469) 844-8880 | 17742 Preston Rd Dallas, TX 75252 | www.StriveRE.com'
                    }
                    <span className='pagination'>{pageNo}/{totalPages}</span>
                </div>
            </React.Fragment>
        )
    }

    let pageIndex = 0;
    let noTables = Math.ceil(listings.length / noPropertiesPerPage);
    const remainingProperties = listings.length % noPropertiesPerPage;
    const hasRemainingProperties = remainingProperties < minNoPropertiesPerPage;
    // if the remainder is 0 another table is needed
    if (!remainingProperties) noTables++;

    return (
        <div className='Print'>
            {
                [...Array(noTables)].map((value, index) => {
                    const isLastPage = index === noTables - 1;
                    const isSecondToLastPage = index === noTables - 2;

                    let lastPageIndex = pageIndex + noPropertiesPerPage;
                    if (hasRemainingProperties && isSecondToLastPage) {
                        lastPageIndex = pageIndex + noPropertiesPerPage - (minNoPropertiesPerPage - remainingProperties);
                    }

                    const data = listings.slice(pageIndex, lastPageIndex);

                    if (hasRemainingProperties && isSecondToLastPage) {
                        pageIndex += noPropertiesPerPage - (minNoPropertiesPerPage - remainingProperties);
                    } else {
                        pageIndex += noPropertiesPerPage;
                    }

                    return (
                        <div key={index} className='print-container'>
                            {renderPage({data, isLastPage, pageNo: index + 1, totalPages: noTables})}
                        </div>
                    )
                })
            }
        </div>
    );
};

export default Print;
